<template>
  <div class="entityIncludedIn">
    <strong>Included In:&nbsp;</strong>
    <span v-if="includedIn.length === 0">--</span>
    <span v-for="(section, index) in sections" :key="section.name">
      <span>
        <span v-if="sections.length > 1 && index === sections.length - 1">&nbsp;and</span>
        <span v-else-if="index > 0">,</span>
        <a :href="section.link">{{ section.count }} {{ section.name }}</a>
      </span>
    </span>
  </div>
</template>

<script>
import sortBy from "lodash/sortBy";

export default {
  name: "EntityIncludedIn",
  props: {
    includedIn: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    sections() {
      return sortBy(this.includedIn, (section) => section.name.toLowerCase());
    },
  }
};
</script>

<style lang="scss">
.entityIncludedIn {
  a {
    cursor: pointer;
  }
}
</style>
